import React, { useEffect } from "react";
import { ArrowLeft, CheckCircle2, CircleDollarSign, Clock3, IndianRupee, ShieldAlert, WalletCards } from "lucide-react";
import { useNavigate } from "react-router-dom";

const bettingRules = [
  { icon: IndianRupee, title: "Minimum bet: Rs 10", note: "Every bet must be at least Rs 10." },
  { icon: CheckCircle2, title: "Place bids before market closing", note: "All bids must be placed before the market close time." },
  { icon: CheckCircle2, title: "Winnings credited instantly", note: "Winning amount is added to wallet after result settlement." },
];

const withdrawRules = [
  { icon: CircleDollarSign, title: "Min: Rs 500", note: "Minimum withdrawal amount is Rs 500." },
  { icon: WalletCards, title: "Max: Rs 100000/day", note: "Maximum withdrawal limit is Rs 100000 in one day." },
  { icon: Clock3, title: "Monday to Sunday", note: "Withdrawals are available all 7 days of the week." },
  { icon: CheckCircle2, title: "9:00 AM to 11:00 PM", note: "Morning 9 AM to night 11 PM." },
];

function GameRules() {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (!user?.id) navigate("/login", { replace: true });
  }, [navigate]);

  return (
    <div style={page}>
      <header style={header}>
        <button type="button" style={backButton} onClick={() => navigate(-1)}>
          <ArrowLeft size={22} />
        </button>
        <h1 style={title}>Game Rules</h1>
        <span style={headerSpacer} />
      </header>

      <main style={content}>
        <RuleSection
          icon={IndianRupee}
          iconColor="#16a34a"
          iconBg="#f0fdf4"
          title="Betting Rules"
          subtitle="Betting conditions for all users"
          items={bettingRules}
        />


        <RuleSection
          icon={WalletCards}
          iconColor="#ea580c"
          iconBg="#fff7ed"
          title="Withdrawal"
          subtitle="Withdrawal limits and request rules"
          items={withdrawRules}
        />

        <section style={noticeCard}>
          <div style={noticeHead}>
            <ShieldAlert size={22} />
            <strong>Important</strong>
          </div>
          <p style={noticeText}>Play responsibly. 18+ only. All bids are final.</p>
        </section>
      </main>
    </div>
  );
}

function RuleSection({ icon: Icon, iconColor, iconBg, title, subtitle, items }) {
  return (
    <section style={section}>
      <div style={sectionHeader}>
        <span style={{ ...sectionIconWrap, background: iconBg, color: iconColor }}>
          <Icon size={20} />
        </span>
        <div>
          <strong style={sectionTitle}>{title}</strong>
          <div style={sectionSubtitle}>{subtitle}</div>
        </div>
      </div>

      <div style={ruleList}>
        {items.map((item) => {
          const ItemIcon = item.icon;
          return (
            <article key={item.title} style={ruleCard}>
              <span style={ruleIcon}>
                <ItemIcon size={18} />
              </span>
              <div style={ruleBody}>
                <strong style={ruleTitle}>{item.title}</strong>
                <p style={ruleNote}>{item.note}</p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

const page = { minHeight: "100vh", background: "#f8fafc", color: "#0f172a" };
const header = { position: "sticky", top: 0, zIndex: 10, height: 62, background: "#fff", borderBottom: "1px solid #e5e7eb", display: "grid", gridTemplateColumns: "48px 1fr 48px", alignItems: "center", padding: "0 14px" };
const backButton = { width: 36, height: 36, border: 0, background: "transparent", display: "grid", placeItems: "center", color: "#1f2937", cursor: "pointer" };
const title = { margin: 0, justifySelf: "center", fontSize: 20, fontWeight: 900 };
const headerSpacer = { width: 36 };
const content = { maxWidth: 560, margin: "0 auto", padding: "18px 12px 32px", display: "grid", gap: 18 };
const section = { background: "#fff", border: "1px solid #e5e7eb", borderRadius: 22, overflow: "hidden", boxShadow: "0 8px 20px rgba(15,23,42,0.04)" };
const sectionHeader = { display: "flex", alignItems: "center", gap: 12, padding: "16px 18px", borderBottom: "1px solid #f1f5f9" };
const sectionIconWrap = { width: 36, height: 36, borderRadius: 12, display: "grid", placeItems: "center" };
const sectionTitle = { display: "block", fontSize: 16, fontWeight: 800 };
const sectionSubtitle = { marginTop: 2, color: "#64748b", fontSize: 12 };
const ruleList = { display: "grid", gap: 14, padding: 16 };
const ruleCard = { display: "grid", gridTemplateColumns: "34px 1fr", gap: 12, alignItems: "start", padding: 16, background: "#f8fafc", borderRadius: 18 };
const ruleIcon = { width: 28, height: 28, borderRadius: 999, display: "grid", placeItems: "center", color: "#16a34a" };
const ruleBody = { display: "grid", gap: 6 };
const ruleTitle = { fontSize: 14, fontWeight: 800, color: "#111827" };
const ruleNote = { margin: 0, color: "#64748b", fontSize: 13, lineHeight: 1.45 };
const noticeCard = { background: "#fff7ed", border: "1px solid #fdba74", borderRadius: 20, padding: 18, color: "#c2410c" };
const noticeHead = { display: "flex", alignItems: "center", gap: 10, fontSize: 18, fontWeight: 900 };
const noticeText = { margin: "10px 0 0", fontSize: 14, lineHeight: 1.5 };

export default GameRules;
